import { IFloatingFilterComp } from 'ag-grid-angular/main';
import { ChangeDetectionStrategy, Component, ViewChild, ElementRef } from '@angular/core';
import { ICellRendererParams, IFloatingFilterParams, SerializedSetFilter } from 'ag-grid-community';

export type BooleanCellValue = 'true' | 'false';

export interface BooleanCellRendererParams extends ICellRendererParams {
    value: BooleanCellValue;
}

export function yesNoRenderer(value: BooleanCellValue) {
    return value === 'true' ? 'Yes' : 'No';
}

export interface BooleanAgFloatingFilterParams extends IFloatingFilterParams<SerializedSetFilter, any> {
    booleanValueRenderer: (value: BooleanCellValue) => string;
}

@Component({
    selector: 'boolean-ag-floating-filter',
    template: '<input #filterInput disabled>',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BooleanAgFloatingFilterComponent implements IFloatingFilterComp {
    @ViewChild('filterInput')
    private filterInput: ElementRef;

    private valueRenderer: (value: BooleanCellValue) => string;

    public agInit(params: BooleanAgFloatingFilterParams) { 
        this.valueRenderer = params.booleanValueRenderer;
    }

    public onParentModelChanged(model: { values: BooleanCellValue[]}) {
        const filterText = model && model.values && model.values.length > 0
            ? this.valueRenderer(model.values[0])
            : '';

        this.filterInput.nativeElement.value = filterText;
    }
}
